module.exports = __webpack_public_path__ + "static/media/logoInove.8fdde0ff.svg";